(function () {
  'use strict';

  var settings = window.JKPrescriptionSettings || {};
  var catalog = { optical: { 'Single Vision': [], Progressive: [], Bifocal: [] }, sunglasses: { 'Single Vision': [], Progressive: [], Bifocal: [] } };
  var copy = settings.copy || {};
  var behavior = settings.behavior || {};
  var contact = settings.contact || {};

  function text(key, fallback) {
    return typeof copy[key] === 'string' && copy[key] !== '' ? copy[key] : fallback;
  }
  function fillText(value, replacements) {
    return Object.keys(replacements || {}).reduce(function (result, key) {
      return result.split('{' + key + '}').join(String(replacements[key]));
    }, String(value == null ? '' : value));
  }
  function configuredFormats() {
    return ['pdf', 'jpg', 'jpeg', 'png'].filter(function (format) { return behavior['rx_upload_' + format] !== false; });
  }
  function formatList(formats) {
    return formats.map(function (format) { return format.toUpperCase(); }).join(', ');
  }
  function acceptedFileText() {
    return fillText(text('rx_error_file_format', 'Choose a {formats} file no larger than {max_mb} MB.'), {
      formats: formatList(configuredFormats()), max_mb: Number(behavior.rx_upload_max_mb) || 20
    });
  }
  function refreshLensCatalog() {
    catalog = { optical: { 'Single Vision': [], Progressive: [], Bifocal: [] }, sunglasses: { 'Single Vision': [], Progressive: [], Bifocal: [] } };
    document.querySelectorAll('[data-jk-rx-lens]').forEach(function (node) {
      var category = node.dataset.category === 'sunglasses' ? 'sunglasses' : 'optical';
      var type = node.dataset.prescriptionType;
      if (!catalog[category][type]) return;
      try {
        var product = JSON.parse(node.textContent || '{}');
        var variants = (product.variants || []).map(function (variant) {
          return { id: Number(variant.id), title: variant.title || '', price: Number(variant.price) || 0,
            available: Boolean(variant.available), image: variant.image || product.image || '' };
        }).filter(function (variant) { return variant.id > 0; });
        if (!product.title || !variants.length) return;
        catalog[category][type].push({
          productId: Number(product.productId), handle: product.handle || '',
          name: node.dataset.displayTitle || product.title, image: product.image || '',
          badge: node.dataset.badge || '', available: Boolean(product.available), variants: variants
        });
      } catch (_) {}
    });
    return catalog;
  }
  function productTitle(product) {
    return product && product.name || text('rx_lens_empty', 'Lens');
  }
  function selectedVariant(product, variantId) {
    return product && product.variants.find(function (variant) { return Number(variant.id) === Number(variantId); });
  }
  function lensLabel(product, variant) {
    var variantName = variant && variant.title && variant.title !== 'Default Title' ? ' · ' + variant.title : '';
    return productTitle(product) + variantName;
  }
  function lensDisplayName(lens) {
    var product = lens && catalog[lens.category] && catalog[lens.category][lens.type] && catalog[lens.category][lens.type][lens.productIndex];
    return product ? lensLabel(product, selectedVariant(product, lens.variant)) : (lens && lens.name || '');
  }

  function route(path) {
    return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + path;
  }
  function cartNotice(message, isError) {
    if (window.JodyKoesTheme && window.JodyKoesTheme.showCartNotice) {
      window.JodyKoesTheme.showCartNotice(message, Boolean(isError));
      return;
    }
    var banner = document.createElement('p');
    banner.className = 'jk-rx-cart-recovery-alert';
    banner.setAttribute('role', isError ? 'alert' : 'status');
    banner.textContent = message;
    (document.querySelector('main') || document.body).prepend(banner);
  }
  function setCheckoutLocked(locked) {
    document.querySelectorAll('button[name="checkout"], input[name="checkout"], a[href*="/checkout"], a[data-jk-rx-was-disabled]').forEach(function (control) {
      if (locked) {
        if (control.dataset.jkRxWasDisabled !== undefined) return;
        control.dataset.jkRxWasDisabled = control.disabled ? 'true' : 'false';
        if (control.tagName !== 'A') control.disabled = true;
        control.setAttribute('aria-disabled', 'true');
        if (control.tagName === 'A') {
          control.dataset.jkRxOriginalHref = control.getAttribute('href') || '';
          control.removeAttribute('href');
          control.tabIndex = -1;
        }
      } else if (control.dataset.jkRxWasDisabled !== undefined) {
        if (control.tagName !== 'A') control.disabled = control.dataset.jkRxWasDisabled === 'true';
        control.removeAttribute('aria-disabled');
        if (control.tagName === 'A') {
          control.setAttribute('href', control.dataset.jkRxOriginalHref || '/checkout');
          control.tabIndex = 0;
          delete control.dataset.jkRxOriginalHref;
        }
        delete control.dataset.jkRxWasDisabled;
      }
    });
  }
  function removeUploadQuery() {
    var cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete('jk_rx_upload');
    cleanUrl.searchParams.delete('jk_rx_buy_now');
    window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
  }
  function readCart() {
    return fetch(route('cart.js'), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error(text('rx_cart_read_failed', 'Cart could not be checked.')); return response.json(); });
  }
  function itemGroup(item) {
    var properties = item && item.properties || {};
    return properties['_JK Prescription Group ID'] || properties['_Prescription Group ID'] || properties['Prescription Group ID'];
  }
  function hasUploadLink(item) {
    var value = item && item.properties && (item.properties._Prescription || item.properties.Prescription);
    return typeof value === 'string' && (/^https?:\/\//i.test(value) || /^\/\//.test(value) || /^\/uploads\//i.test(value));
  }
  function hasLensForGroup(cart, groupId) {
    return cart.items.some(function (item) {
      return itemGroup(item) === groupId && item.properties && item.properties['Purchase Type'] === 'Prescription Lens';
    });
  }
  function removeGroupItems(cart, groupId) {
    return cart.items.filter(function (item) { return itemGroup(item) === groupId; })
      .reduce(function (chain, item) {
        return chain.then(function () { return window.JodyKoesTheme.changeCartLine(item.key, 0); });
      }, Promise.resolve()).then(readCart);
  }
  function normalizeGroupQuantities(cart, groupId) {
    return cart.items.filter(function (item) { return itemGroup(item) === groupId && item.quantity !== 1; })
      .reduce(function (chain, item) {
        return chain.then(function () { return window.JodyKoesTheme.changeCartLine(item.key, 1); });
      }, Promise.resolve()).then(readCart);
  }
  function clearUploadRecovery(message, isError, cart, pending) {
    if (!isError && pending && pending.buyNow && !cartIsOnlyPrescriptionPair(cart, pending.groupId)) {
      return removeGroupItems(cart, pending.groupId).then(function (cleanedCart) {
        return clearUploadRecovery(text('rx_recovery_changed_cart', 'Your cart changed during checkout preparation. The prescription pair was removed and your other cart items were kept.'), true, cleanedCart, null);
      }).catch(function () {
        pauseCheckout(text('rx_recovery_changed_cart_paused', 'Your cart changed during checkout preparation. We could not safely verify the pair, so checkout is paused. Retry the cart check.'));
      });
    }
    try { window.sessionStorage.removeItem('jkRxUploadPending'); } catch (_) {}
    removeUploadQuery();
    var recoveryBanner = document.getElementById('jk-rx-upload-recovery-alert');
    if (recoveryBanner) recoveryBanner.remove();
    var cartSync = Promise.resolve();
    if (cart && window.JodyKoesTheme && typeof window.JodyKoesTheme.broadcastCart === 'function') {
      window.JodyKoesTheme.broadcastCart(cart);
      if (typeof window.JodyKoesTheme.syncCartSectionToCart === 'function') {
        cartSync = window.JodyKoesTheme.syncCartSectionToCart(cart);
      } else {
        document.dispatchEvent(new CustomEvent('jodykoes:cart:section:sync', { detail: { cart: cart } }));
      }
    }
    return Promise.resolve(cartSync).then(function () {
      document.documentElement.classList.remove('jk-rx-cart-pending');
      setCheckoutLocked(false);
      cartNotice(message, isError);
      if (!isError && pending && pending.buyNow) return triggerMagicCheckout(cart, pending.groupId);
    });
  }
  function pauseCheckout(message) {
    document.documentElement.classList.remove('jk-rx-cart-pending');
    setCheckoutLocked(true);
    var banner = document.getElementById('jk-rx-upload-recovery-alert');
    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'jk-rx-upload-recovery-alert';
      banner.className = 'jk-rx-cart-recovery-alert';
      banner.setAttribute('role', 'alert');
      var recoveryMessageElement = document.createElement('span');
      recoveryMessageElement.dataset.jkRxRecoveryMessage = 'true';
      var retry = document.createElement('button');
      retry.type = 'button';
      retry.textContent = text('rx_recovery_retry', 'Retry cart check');
      retry.addEventListener('click', function () { window.location.reload(); });
      banner.append(recoveryMessageElement, retry);
      (document.querySelector('main') || document.body).prepend(banner);
    }
    banner.querySelector('[data-jk-rx-recovery-message]').textContent = message;
  }
  function recoverNativeUpload() {
    var url = new URL(window.location.href);
    var pending = null;
    try { pending = JSON.parse(window.sessionStorage.getItem('jkRxUploadPending') || 'null'); } catch (_) {}
    var groupId = url.searchParams.get('jk_rx_upload') || (pending && Date.now() - Number(pending.attemptedAt || 0) < 10 * 60 * 1000 ? pending.groupId : '');
    if (!groupId) return Promise.resolve();
    setCheckoutLocked(true);

    return readCart().then(function (cart) {
      var frame = cart.items.find(function (item) {
        return itemGroup(item) === groupId && item.properties && item.properties['Purchase Type'] === 'Prescription Frame';
      });
      if (!frame) {
        if (hasLensForGroup(cart, groupId)) {
          return removeGroupItems(cart, groupId).then(function (cleanedCart) {
            return clearUploadRecovery(text('rx_recovery_unmatched_lens_removed', 'Shopify did not add the frame and prescription. The unmatched lens was removed. Please try again.'), true, cleanedCart);
          });
        }
        return clearUploadRecovery(text('rx_recovery_missing_frame', 'Shopify did not add the frame and prescription. Please try again.'), true, cart);
      }
      if (!hasUploadLink(frame) || !pending || pending.groupId !== groupId || Number(frame.variant_id) !== Number(pending.frameVariant)) {
        return removeGroupItems(cart, groupId).then(function (cleanedCart) {
          return clearUploadRecovery(text('rx_recovery_upload_unverified', 'The prescription upload could not be verified, so the unmatched frame was removed from your cart. Please try again or choose Email later or WhatsApp us later.'), true, cleanedCart);
        }).catch(function () {
          pauseCheckout(text('rx_recovery_upload_cleanup_failed', 'We could not finish or safely remove this prescription order. Checkout is paused until the cart check succeeds.'));
        });
      }
      if (hasLensForGroup(cart, groupId)) {
        return normalizeGroupQuantities(cart, groupId).then(function (normalizedCart) {
          return clearUploadRecovery(text('rx_recovery_success', 'Your prescription, frame, and matching lens are in your cart.'), false, normalizedCart, pending);
        }).catch(function () {
          pauseCheckout(text('rx_recovery_quantity_failed', 'We could not confirm the frame and lens quantities. Checkout is paused; retry the cart check.'));
        });
      }
      var lensProperties = {
        'Purchase Type': 'Prescription Lens',
        '_JK Prescription Group ID': groupId,
        'Product Category': pending.category,
        'Prescription Type': pending.type,
        'Submission Method': 'Upload Prescription',
        'Prescription Status': 'Prescription uploaded',
        'Associated Frame': pending.frameName
      };
      return fetch(route('cart/add.js'), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(pending.lensVariant), quantity: 1, properties: lensProperties })
      }).then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) throw new Error(payload.description || payload.message || text('rx_recovery_lens_add_failed', 'The matching lens could not be added.'));
        });
      }).then(readCart).then(function (updatedCart) {
        if (!hasLensForGroup(updatedCart, groupId)) throw new Error(text('rx_recovery_lens_not_confirmed', 'The matching lens was not confirmed in the cart.'));
        return clearUploadRecovery(text('rx_recovery_success', 'Your prescription, frame, and matching lens are in your cart.'), false, updatedCart, pending);
      }).catch(function (addError) {
        return readCart().then(function (latestCart) {
          if (hasLensForGroup(latestCart, groupId)) {
            return normalizeGroupQuantities(latestCart, groupId).then(function (normalizedCart) {
            return clearUploadRecovery(text('rx_recovery_success', 'Your prescription, frame, and matching lens are in your cart.'), false, normalizedCart, pending);
            });
          }
          var latestFrame = latestCart.items.find(function (item) { return itemGroup(item) === groupId && item.properties && item.properties['Purchase Type'] === 'Prescription Frame'; });
          if (!latestFrame) {
            return clearUploadRecovery(text('rx_recovery_no_frame', 'The matching lens could not be added. No unmatched frame remains in your cart.'), true, latestCart);
          }
          return removeGroupItems(latestCart, groupId).then(function (cleanedCart) {
            return clearUploadRecovery(text('rx_recovery_frame_removed', 'The matching lens could not be added, so the frame was removed from your cart. Please try again or choose Email later or WhatsApp us later.'), true, cleanedCart);
          });
        }).catch(function () {
          pauseCheckout((addError && addError.message ? addError.message + ' ' : '') + text('rx_recovery_safe_check_failed', 'We could not confirm safe recovery. Checkout is paused. Retry the cart check.'));
        });
      });
    }).catch(function () {
      pauseCheckout(text('rx_recovery_order_unconfirmed', 'We could not confirm the prescription order in your cart. Checkout is paused. Retry the cart check.'));
    });
  }
  recoverNativeUpload();

  var modal = document.querySelector('[data-jk-rx]');
  if (!modal) return;
  var body = modal.querySelector('[data-jk-rx-body]');
  var modalContent = modal.querySelector('.jk-rx-content');
  var title = modal.querySelector('[data-jk-rx-title]');
  var error = modal.querySelector('[data-jk-rx-error]');
  var next = modal.querySelector('[data-jk-rx-next]');
  var back = modal.querySelector('[data-jk-rx-back]');
  var buyNowButton = modal.querySelector('[data-jk-rx-buy-now]');
  var progress = modal.querySelector('[data-jk-rx-progress]');
  var total = modal.querySelector('[data-jk-rx-total]');
  var frameOnly = modal.querySelector('[data-jk-rx-frame-only]');
  var uploadPanel = modal.querySelector('[data-jk-rx-upload]');
  var fileInput = modal.querySelector('[data-jk-rx-file]');
  var fileName = modal.querySelector('[data-jk-rx-file-name]');
  var removeFile = modal.querySelector('[data-jk-rx-remove-file]');
  var uploadConsent = modal.querySelector('[data-jk-rx-upload-consent]');
  var uploadPropertyFields = modal.querySelectorAll('[data-jk-rx-upload-property], [name="properties[Purchase Type]"], [name="properties[Submission Method]"], [name="properties[Prescription Status]"]');
  var state = null;
  var focusBeforeOpen = null;
  var renderedStep = '';
  var priceCache = {};
  var variantPriceVerified = {};

  function money(cents) {
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || settings.currency || 'INR';
    var locale = settings.locale || 'en-IN';
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, maximumFractionDigits: 2 }).format((Number(cents) || 0) / 100); }
    catch (_) { return currency + ' ' + ((Number(cents) || 0) / 100).toFixed(2); }
  }
  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }
  function showError(message) {
    error.textContent = message;
    error.hidden = !message;
  }
  function open(button) {
    refreshLensCatalog();
    priceCache = {};
    variantPriceVerified = {};
    focusBeforeOpen = document.activeElement;
    var form = button.closest('form');
    var variantControl = form && form.querySelector('[data-product-variant-select]');
    var selectedOption = variantControl && variantControl.tagName === 'SELECT' ? variantControl.options[variantControl.selectedIndex] : variantControl;
    state = {
      button: button, category: button.dataset.category === 'sunglasses' ? 'sunglasses' : 'optical',
      form: form, frameId: Number(variantControl ? variantControl.value : button.dataset.variantId),
      framePrice: Number(selectedOption && selectedOption.dataset.price || button.dataset.variantPrice) || 0,
      frameName: button.dataset.productTitle || text('rx_frame_fallback', 'Selected frame'), type: '', method: '', lens: null,
      step: 'type', eye: { od: { sph: '', cyl: '', axis: '', add: '' }, os: { sph: '', cyl: '', axis: '', add: '' } },
      pdMode: 'single', pd: '', rpd: '', lpd: '', uploadFile: null
    };
    renderedStep = '';
    if (fileInput) {
      fileInput.value = '';
      fileInput.accept = configuredFormats().map(function (format) {
        return ({ pdf: '.pdf,application/pdf', jpg: '.jpg,image/jpeg', jpeg: '.jpeg,image/jpeg', png: '.png,image/png' })[format];
      }).join(',');
    }
    if (fileName) fileName.textContent = text('rx_file_empty', 'No file selected');
    if (removeFile) removeFile.hidden = true;
    if (uploadConsent) { uploadConsent.checked = false; uploadConsent.disabled = true; }
    var consentCopy = modal.querySelector('[data-jk-rx-upload-consent-copy]');
    var privacyCopy = modal.querySelector('[data-jk-rx-upload-privacy]');
    var fileReplacements = { formats: formatList(configuredFormats()), max_mb: Number(behavior.rx_upload_max_mb) || 20 };
    if (consentCopy) consentCopy.textContent = fillText(text('rx_upload_consent', ''), fileReplacements);
    if (privacyCopy) privacyCopy.textContent = fillText(text('rx_upload_privacy', ''), fileReplacements);
    uploadPropertyFields.forEach(function (field) { field.disabled = true; field.value = field.name === 'properties[Purchase Type]' ? 'Prescription Frame' : (field.name === 'properties[Submission Method]' ? 'Upload Prescription' : (field.name === 'properties[Prescription Status]' ? 'Prescription uploaded' : '')); });
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('jk-rx-open');
    modal.querySelector('[data-jk-rx-product]').textContent = state.frameName;
    var image = modal.querySelector('[data-jk-rx-image]');
    if (button.dataset.productImage) { image.src = button.dataset.productImage; image.hidden = false; }
    else { image.removeAttribute('src'); image.hidden = true; }
    render();
    modal.querySelector('.jk-rx-close').focus();
  }
  function close() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('jk-rx-open');
    if (focusBeforeOpen && focusBeforeOpen.focus) focusBeforeOpen.focus();
  }
  function options(min, max, increment, signed) {
    var result = [['', 'Select']];
    for (var n = min; n <= max + 0.000001; n += increment) {
      var value = n.toFixed(2);
      if (n > 0 && signed) value = '+' + value;
      result.push([value, value]);
    }
    return result;
  }
  function selectField(label, key, values, selected) {
    var optional = key === 'pd' || key === 'rpd' || key === 'lpd';
    var placeholder = text(optional ? 'rx_pd_unknown' : 'rx_select_placeholder', optional ? 'I don’t know' : 'Select');
    return '<label>' + escapeHtml(label) + '<select data-field="' + key + '"' + (optional ? '' : ' required') + '><option value="">' + escapeHtml(placeholder) + '</option>' +
      values.filter(function (option) { return option[0] !== ''; }).map(function (option) {
        return '<option value="' + escapeHtml(option[0]) + '" ' + (option[0] === selected ? 'selected' : '') + '>' + escapeHtml(option[1]) + '</option>';
      }).join('') + '</select></label>';
  }
  function render() {
    showError('');
    next.disabled = false;
    if (buyNowButton) { buyNowButton.disabled = false; buyNowButton.removeAttribute('aria-busy'); buyNowButton.textContent = text('rx_button_buy_now', 'Buy now'); }
    back.hidden = state.step === 'type';
    next.hidden = state.type === 'Frame Only' || state.step === 'method';
    if (buyNowButton) buyNowButton.hidden = state.step !== 'review' || state.type === 'Frame Only' || behavior.rx_enable_buy_now === false;
    frameOnly.hidden = state.type !== 'Frame Only';
    if (uploadPanel) uploadPanel.hidden = state.step !== 'upload';
    if (fileInput) fileInput.disabled = state.step !== 'upload';
    if (uploadConsent) uploadConsent.disabled = state.step !== 'upload';
    total.textContent = money(state.framePrice + (state.lens ? state.lens.price : 0));
    var progressKeys = { type: 'rx_step_type', method: 'rx_step_method', prescription: 'rx_step_prescription', upload: 'rx_step_upload', lens: 'rx_step_lens', review: 'rx_step_review' };
    progress.textContent = text(progressKeys[state.step], '');
    progress.dataset.step = state.step;
    progress.style.setProperty('--jk-rx-progress', ({ type: '20%', method: '40%', prescription: '60%', upload: '60%', lens: '80%', review: '100%' })[state.step] || '20%');
    next.textContent = state.step === 'review' ? text(state.method === 'Upload Prescription' ? 'rx_button_upload_add' : 'rx_button_add', state.method === 'Upload Prescription' ? 'Upload and add to cart' : 'Add to cart') : text('rx_button_continue', 'Continue');
    body.innerHTML = '';
    if (modalContent && renderedStep !== state.step) {
      modalContent.scrollTop = 0;
      renderedStep = state.step;
    }

    if (state.step === 'type') {
      title.textContent = text('rx_heading_type', 'Choose your prescription');
      var typeChoices = [
        ['Single Vision', text('rx_type_single', 'Single Vision')],
        ['Progressive', text('rx_type_progressive', 'Progressive')],
        ['Bifocal', text('rx_type_bifocal', 'Bifocal')]
      ].map(function (item) { return '<button type="button" class="jk-rx-choice" data-type="' + escapeHtml(item[0]) + '">' + escapeHtml(item[1]) + '</button>'; });
      if (behavior.rx_enable_frame_only !== false) typeChoices.push('<button type="button" class="jk-rx-choice" data-type="Frame Only">' + escapeHtml(text('rx_type_frame_only', 'Frame Only')) + '</button>');
      body.innerHTML = typeChoices.join('');
    } else if (state.step === 'method') {
      title.textContent = text('rx_heading_method', 'How will you submit your prescription?');
      var methodChoices = [];
      if (behavior.rx_enable_manual !== false) methodChoices.push('<button type="button" class="jk-rx-choice" data-method="Manually">' + escapeHtml(text('rx_method_manual', 'Enter prescription manually')) + '</button>');
      if (behavior.rx_enable_later !== false) methodChoices.push('<button type="button" class="jk-rx-choice" data-method="Email or WhatsApp Later">' + escapeHtml(text('rx_method_later', 'Email later or WhatsApp us later')) + '</button>');
      if (behavior.rx_enable_upload !== false && configuredFormats().length) methodChoices.push('<button type="button" class="jk-rx-choice" data-method="Upload Prescription">' + escapeHtml(text('rx_method_upload', 'Upload a prescription file')) + '</button>');
      body.innerHTML = methodChoices.join('') +
        '<div class="jk-rx-contact-copy"><p>' + contactMarkup('rx_contact_intro', 'rx_contact_connector') + '</p><p>' + escapeHtml(text('rx_pending_explanation', 'Your order will be marked pending until we receive it.')) + '</p></div>';
    } else if (state.step === 'prescription') {
      var typeName = state.type.toLocaleLowerCase(settings.locale || undefined);
      title.textContent = text('rx_heading_manual_prefix', 'Enter your') + ' ' + typeName + ' ' + text('rx_heading_manual_suffix', 'prescription');
      var html = '<p class="jk-rx-form-intro">' + escapeHtml(text('rx_manual_intro', 'Enter values exactly as shown on your prescription.')) + '</p>';
      ['od', 'os'].forEach(function (eye) {
        var right = eye === 'od';
        html += '<div class="jk-rx-row"><strong>' + escapeHtml(text(right ? 'rx_eye_right' : 'rx_eye_left', right ? 'OD · Right eye' : 'OS · Left eye')) + '</strong>' +
          selectField(text('rx_field_sph', 'SPH'), eye + 'sph', options(-20, 20, .25, true), state.eye[eye].sph) +
          selectField(text('rx_field_cyl', 'CYL'), eye + 'cyl', options(-6, 6, .25, true), state.eye[eye].cyl) +
          selectField(text('rx_field_axis', 'AXIS'), eye + 'axis', [['', text('rx_select_placeholder', 'Select')]].concat(Array.from({ length: 180 }, function (_, i) { var v = String(i + 1).padStart(3, '0'); return [v, v]; })), state.eye[eye].axis);
        if (state.type !== 'Single Vision') html += selectField(text('rx_field_add', 'ADD'), eye + 'add', options(.25, 4, .25, true), state.eye[eye].add);
        html += '</div>';
      });
      html += '<label class="jk-rx-check"><input type="checkbox" data-dual ' + (state.pdMode === 'dual' ? 'checked' : '') + '> ' + escapeHtml(text('rx_pd_toggle', 'Enter two PD numbers')) + '</label>';
      html += '<div class="jk-rx-pd-single" data-pd-single ' + (state.pdMode === 'dual' ? 'hidden' : '') + '>' + selectField(text('rx_pd_single', 'PD (mm, optional)'), 'pd', options(40, 80, .5, false), state.pd) + '</div>';
      html += '<div class="jk-rx-pd-dual" data-pd-dual ' + (state.pdMode === 'single' ? 'hidden' : '') + '>' +
        selectField(text('rx_pd_right', 'Right PD (mm, optional)'), 'rpd', options(20, 40, .5, false), state.rpd) +
        selectField(text('rx_pd_left', 'Left PD (mm, optional)'), 'lpd', options(20, 40, .5, false), state.lpd) + '</div>';
      html += '<p class="jk-rx-pd-help">' + escapeHtml(text('rx_pd_help', 'PD is optional. If you do not know it, leave it blank.')) + '</p>';
      body.innerHTML = html;
    } else if (state.step === 'upload') {
      title.textContent = text('rx_heading_upload', 'Upload your prescription');
      body.innerHTML = '<p>' + escapeHtml(text('rx_upload_intro', 'Choose a clear photo or PDF of your prescription.')) + '</p>';
    } else if (state.step === 'lens') {
      title.textContent = text('rx_heading_lens', 'Choose your lens');
      var lenses = catalog[state.category][state.type] || [];
      body.innerHTML = lenses.length ? '<div class="jk-rx-lenses">' + lenses.map(function (product, index) {
        return renderLensProduct(product, index);
      }).join('') + '</div>' : '<p class="jk-rx-lens-empty">' + escapeHtml(text('rx_lens_empty', 'No lenses are available for this prescription type.')) + '</p>';
      loadPrices(lenses);
    } else if (state.step === 'review') {
      title.textContent = text('rx_heading_review', 'Review your order');
      var statusKey = state.method === 'Email or WhatsApp Later' ? 'rx_status_pending' : (state.method === 'Upload Prescription' ? 'rx_status_upload_ready' : 'rx_status_entered');
      var statusFallback = state.method === 'Email or WhatsApp Later' ? 'Prescription pending' : (state.method === 'Upload Prescription' ? 'Prescription ready to upload' : 'Prescription details entered');
      var reviewType = state.type === 'Single Vision' ? text('rx_type_single', state.type) : (state.type === 'Progressive' ? text('rx_type_progressive', state.type) : text('rx_type_bifocal', state.type));
      body.innerHTML = '<div class="jk-rx-review">' +
        '<div class="jk-rx-review-status"><span class="jk-rx-status-dot"></span><span>' + escapeHtml(text(statusKey, statusFallback)) + '</span><span class="jk-rx-review-type">' + escapeHtml(reviewType) + '</span></div>' +
        '<div class="jk-rx-review-items"><div><span>' + escapeHtml(text('rx_review_lens_label', 'Selected lens')) + '</span><strong>' + escapeHtml(lensDisplayName(state.lens)) + '</strong><b>' + money(state.lens.price) + '</b></div><div><span>' + escapeHtml(text('rx_review_frame_label', 'Frame')) + '</span><strong>' + escapeHtml(state.frameName) + '</strong><b>' + money(state.framePrice) + '</b></div></div>' +
        (behavior.rx_enable_buy_now !== false ? '<p class="jk-rx-buy-now-note">' + escapeHtml(text('rx_review_cart_note', 'Buy now checks out only this frame and lens, so your cart must be empty. Use Add to cart to keep other items.')) + '</p>' : '') +
        (state.method === 'Manually' ? '<details class="jk-rx-review-details"><summary>' + escapeHtml(text('rx_review_details_label', 'Review prescription details')) + '</summary>' + summary() + '</details>' : '') +
        (state.method === 'Upload Prescription' ? '<p class="jk-rx-review-note">' + escapeHtml(text('rx_review_upload_note', 'Your selected file will be attached to the order.')) + '</p>' : '') +
        (state.method === 'Email or WhatsApp Later' ? '<div class="jk-rx-review-note">' + contactMarkup('rx_review_contact_intro', 'rx_review_contact_connector') + '</div>' : '') + '</div>';
    }
  }
  function contactMarkup(introKey, connectorKey) {
    var email = String(contact.email || '').trim();
    var country = String(contact.whatsappCountryCode || '').replace(/\D/g, '');
    var phone = String(contact.whatsappNumber || '').replace(/\D/g, '');
    var emailLink = email ? '<a href="mailto:' + encodeURIComponent(email).replace(/%40/gi, '@') + '">' + escapeHtml(email) + '</a>' : '';
    var whatsappLink = phone ? '<a href="https://wa.me/' + escapeHtml(country + phone) + '?text=' + encodeURIComponent(contact.whatsappMessage || '') + '" target="_blank" rel="noopener noreferrer">' + escapeHtml((country ? '+' + country + ' ' : '') + phone) + '</a>' : '';
    var intro = text(introKey, 'After ordering, send your prescription and order number to');
    var connector = text(connectorKey, 'or WhatsApp us at');
    return escapeHtml(intro) + (emailLink ? ' ' + emailLink : '') + (whatsappLink ? ' ' + escapeHtml(connector) + ' ' + whatsappLink : '');
  }
  function renderLensProduct(product, index) {
    var availableVariants = product.variants.filter(function (variant) { return variant.available; });
    var selectedId = state.lens && state.lens.productIndex === index ? state.lens.variant : (availableVariants[0] && availableVariants[0].id);
    var variant = selectedVariant(product, selectedId) || product.variants[0];
    var selected = Boolean(state.lens && state.lens.productIndex === index);
    var unavailable = !availableVariants.length || !product.available;
    var image = behavior.rx_show_lens_photos === false || !product.image ? '' : '<img src="' + escapeHtml(variant && variant.image || product.image) + '" alt="' + escapeHtml(productTitle(product)) + '" loading="lazy">';
    var price = unavailable ? text('rx_lens_sold_out', 'Sold out') : (variant && priceCache[variant.id] != null ? money(priceCache[variant.id]) : text('rx_lens_loading', 'Loading price…'));
    var badge = product.badge ? '<em>' + escapeHtml(product.badge) + '</em>' : '';
    var variantSelect = product.variants.length > 1 ? '<label class="jk-rx-lens-variant"><span>' + escapeHtml(text('rx_lens_variant_label', 'Lens option')) + '</span><select data-lens-variant="' + index + '" aria-label="' + escapeHtml(text('rx_lens_variant_label', 'Lens option')) + '">' + product.variants.map(function (option) {
      var label = option.title && option.title !== 'Default Title' ? option.title : productTitle(product);
      var optionPrice = priceCache[option.id] == null ? option.price : priceCache[option.id];
      return '<option value="' + option.id + '" data-variant-title="' + escapeHtml(label) + '" data-price="' + option.id + '" ' + (Number(option.id) === Number(selectedId) ? 'selected' : '') + (option.available && !unavailable && priceCache[option.id] != null ? '' : ' disabled') + '>' + escapeHtml(label + ' · ' + money(optionPrice)) + '</option>'; 
    }).join('') + '</select></label>' : '';
    return '<div class="jk-rx-lens-option' + (selected ? ' selected' : '') + '"><button type="button" class="jk-rx-lens' + (selected ? ' selected' : '') + '" data-lens="' + index + '" aria-pressed="' + (selected ? 'true' : 'false') + '"' + (unavailable ? ' disabled' : '') + '>' + image + '<span class="jk-rx-lens-copy"><b>' + escapeHtml(productTitle(product)) + '</b><span class="jk-rx-lens-price" data-price="' + (variant ? variant.id : '') + '">' + escapeHtml(price) + '</span></span>' + badge + '</button>' + variantSelect + '</div>';
  }
  function summary() {
    var parts = ['od', 'os'].map(function (eye) {
      var eyeCode = text(eye === 'od' ? 'rx_eye_code_right' : 'rx_eye_code_left', eye.toUpperCase());
      var line = escapeHtml(eyeCode) + ': ' + escapeHtml(text('rx_field_sph', 'SPH')) + ' ' + escapeHtml(state.eye[eye].sph) + ' / ' +
        escapeHtml(text('rx_field_cyl', 'CYL')) + ' ' + escapeHtml(state.eye[eye].cyl) + ' / ' + escapeHtml(text('rx_field_axis', 'AXIS')) + ' ' + escapeHtml(state.eye[eye].axis);
      if (state.type !== 'Single Vision') line += ' / ' + escapeHtml(text('rx_field_add', 'ADD')) + ' ' + escapeHtml(state.eye[eye].add);
      return '<p>' + line + '</p>';
    });
    if (state.pdMode === 'single' && state.pd) parts.push('<p>' + escapeHtml(text('rx_pd_single', 'PD')) + ' ' + escapeHtml(state.pd) + '</p>');
    if (state.pdMode === 'dual') {
      if (state.rpd) parts.push('<p>' + escapeHtml(text('rx_pd_right', 'Right PD')) + ' ' + escapeHtml(state.rpd) + '</p>');
      if (state.lpd) parts.push('<p>' + escapeHtml(text('rx_pd_left', 'Left PD')) + ' ' + escapeHtml(state.lpd) + '</p>');
    }
    return parts.join('');
  }
  function loadPrices(lenses) {
    var variants = [];
    (lenses || []).forEach(function (product) {
      product.variants.forEach(function (variant) {
        if (variant.available && !variantPriceVerified[variant.id]) variants.push({ product: product, variant: variant });
      });
    });
    if (!variants.length) return;
    Promise.all(variants.map(function (entry) {
      var id = entry.variant.id;
      return fetch(route('variants/' + id + '.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { if (!response.ok) throw new Error('Variant price request failed'); return response.json(); })
        .then(function (current) {
          if (Number(current.id) !== Number(id)) throw new Error('Shopify returned a different lens variant');
          entry.variant.available = Boolean(current.available);
          if (current.available) priceCache[id] = Number(current.price);
          variantPriceVerified[id] = true;
          return true;
        }).catch(function () { return false; });
    })).then(function (results) {
      var prices = body.querySelectorAll('[data-price]');
      prices.forEach(function (node) {
        var id = Number(node.dataset.price);
        if (priceCache[id] != null) node.textContent = money(priceCache[id]);
      });
      body.querySelectorAll('[data-lens-variant] option[data-price]').forEach(function (option) {
        var id = Number(option.dataset.price);
        if (priceCache[id] != null) option.textContent = option.dataset.variantTitle + ' · ' + money(priceCache[id]);
        var currentVariant = selectedVariantForNode(option);
        option.disabled = !currentVariant || !currentVariant.available || priceCache[id] == null;
      });
      body.querySelectorAll('[data-lens]').forEach(function (button) {
        var product = lenses[Number(button.dataset.lens)];
        if (product && (!product.available || !product.variants.some(function (variant) { return variant.available; }))) {
          button.disabled = true;
          var priceNode = button.querySelector('[data-price]');
          if (priceNode) priceNode.textContent = text('rx_lens_sold_out', 'Sold out');
        }
      });
      if (state && state.lens) {
        var currentLens = catalog[state.category][state.type][state.lens.productIndex];
        var currentVariant = selectedVariant(currentLens, state.lens.variant);
        if (!currentVariant || !currentVariant.available) state.lens = null;
        else if (priceCache[currentVariant.id] != null) state.lens.price = priceCache[currentVariant.id];
      }
      total.textContent = money(state.framePrice + (state.lens ? state.lens.price : 0));
      if (results.some(function (result) { return !result; }) && state.step === 'lens') {
        showError(text('rx_error_price_verify', 'We could not verify an available lens and its current price. Please try again later.'));
      }
    });
  }
  function selectedVariantForNode(option) {
    var select = option.closest('select[data-lens-variant]');
    var product = select && catalog[state.category][state.type][Number(select.dataset.lensVariant)];
    return product && selectedVariant(product, option.value);
  }
  function validate() {
    if (state.step === 'prescription') {
      for (var eye of ['od', 'os']) {
        if (!state.eye[eye].sph || !state.eye[eye].cyl) return text('rx_error_manual_fields', 'Enter SPH and CYL for both eyes.');
        if (state.eye[eye].cyl !== '0.00' && !state.eye[eye].axis) return text('rx_error_axis', 'Select AXIS for each non-zero CYL value.');
        if (state.type !== 'Single Vision' && !state.eye[eye].add) return text('rx_error_add', 'Enter ADD for both eyes.');
      }
    }
    if (state.step === 'upload') {
      if (!state.uploadFile || !fileInput || !fileInput.files || !fileInput.files.length) return text('rx_error_file_missing', 'Choose a prescription file before continuing.');
      if (!isAcceptedFile(state.uploadFile)) return acceptedFileText();
      if (!uploadConsent || !uploadConsent.checked) return text('rx_error_file_consent', 'Confirm the file access notice or choose Email later or WhatsApp us later.');
    }
    if (state.step === 'lens' && (!state.lens || priceCache[state.lens.variant] == null)) return text('rx_error_lens_required', 'Select an available lens after its current price has loaded.');
    return '';
  }
  function isAcceptedFile(file) {
    var maxBytes = (Number(behavior.rx_upload_max_mb) || 20) * 1000 * 1000;
    if (!file || !Number.isFinite(Number(file.size)) || Number(file.size) <= 0 || Number(file.size) > maxBytes) return false;
    var extension = String(file.name || '').split('.').pop().toLowerCase();
    if (configuredFormats().indexOf(extension) === -1) return false;
    var acceptedMime = { pdf: 'application/pdf', jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png' }[extension];
    var mime = String(file.type || '').toLowerCase();
    return !mime || mime === acceptedMime || (extension === 'jpg' && mime === 'image/jpg');
  }
  function commonProperties(groupId) {
    var values = {
      '_JK Prescription Group ID': groupId,
      'Product Category': state.category === 'optical' ? 'Optical Glasses' : 'Sunglasses',
      'Prescription Type': state.type,
      'Submission Method': state.method,
      'Prescription Status': state.method === 'Email or WhatsApp Later' ? 'PENDING — CUSTOMER WILL EMAIL OR WHATSAPP LATER' : 'Prescription entered',
      'Selected Lens': state.lens.name,
    };
    if (state.method === 'Manually') {
      ['od', 'os'].forEach(function (eye) {
        ['sph', 'cyl', 'axis'].forEach(function (field) { values[eye.toUpperCase() + ' ' + field.toUpperCase()] = state.eye[eye][field] || '0.00'; });
        if (state.type !== 'Single Vision') values[eye.toUpperCase() + ' ADD'] = state.eye[eye].add;
      });
      if (state.pdMode === 'single' && state.pd) {
        values['PD Mode'] = 'Single';
        values.PD = state.pd;
      } else if (state.pdMode === 'dual' && (state.rpd || state.lpd)) {
        values['PD Mode'] = 'Dual';
        if (state.rpd) values['Right PD'] = state.rpd;
        if (state.lpd) values['Left PD'] = state.lpd;
      }
    }
    return values;
  }
  function notifyCart(cart, message) {
    window.JodyKoesCart = cart;
    if (window.JodyKoesTheme && typeof window.JodyKoesTheme.broadcastCart === 'function') {
      window.JodyKoesTheme.broadcastCart(cart);
    } else {
      var count = document.getElementById('cartCount');
      if (count) count.textContent = cart.item_count;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }
    if (window.JodyKoesTheme && typeof window.JodyKoesTheme.showCartNotice === 'function') {
      window.JodyKoesTheme.showCartNotice(message, false);
    }
    document.dispatchEvent(new CustomEvent('jodykoes:cart:item-added', { detail: { cart: cart } }));
  }
  function fetchFreshCart() {
    return fetch(route('cart.js'), {
      credentials: 'same-origin', cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error(text('rx_cart_refresh_failed', 'Shopify could not refresh the cart.'));
      return response.json();
    });
  }
  function postCartItems(items) {
    return fetch(route('cart/add.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || text('rx_cart_update_failed', 'The cart could not be updated.'));
        return data;
      });
    });
  }
  function cartLineMatchesExpected(line, expected) {
    if (Number(line.variant_id) !== Number(expected.id)) return false;
    var actualProperties = line.properties || {};
    return Object.keys(expected.properties || {}).every(function (key) {
      return String(actualProperties[key] == null ? '' : actualProperties[key]) === String(expected.properties[key]);
    });
  }
  function cartContainsExpected(cart, expected) {
    return expected.every(function (wanted) {
      return cart.items.some(function (line) {
        return cartLineMatchesExpected(line, wanted) && Number(line.quantity) >= Number(wanted.quantity || 1);
      });
    });
  }
  function cartIsOnlyPrescriptionPair(cart, groupId) {
    if (!cart || !Array.isArray(cart.items) || cart.items.length !== 2 || Number(cart.item_count) !== 2) return false;
    var group = cart.items.filter(function (line) { return itemGroup(line) === groupId && Number(line.quantity) === 1; });
    return group.length === 2 && group.some(function (line) { return line.properties && line.properties['Purchase Type'] === 'Prescription Frame'; }) &&
      group.some(function (line) { return line.properties && line.properties['Purchase Type'] === 'Prescription Lens'; });
  }
  function waitForMagicCheckout(attempt) {
    if (window.JKRazorpayMagicScriptLoaded === true) return Promise.resolve(true);
    if (attempt >= 50 || window.JKRazorpayMagicScriptLoaded === false) return Promise.resolve(false);
    return delay(100).then(function () { return waitForMagicCheckout(attempt + 1); });
  }
  function triggerMagicCheckout(cart, groupId) {
    if (!cartIsOnlyPrescriptionPair(cart, groupId)) {
      cartNotice(text('rx_error_checkout_pair', 'Your cart changed before checkout began. The prescription pair was not sent to checkout.'));
      return Promise.resolve(false);
    }
    return waitForMagicCheckout(0).then(function (ready) {
      if (!ready) {
        cartNotice(text('rx_notice_magic_not_loaded', 'Your frame and matching lens are in your cart, but Razorpay Magic Checkout could not be opened. Continue from the cart or try again.'), true);
        return false;
      }
      var trigger = document.querySelector('[data-jk-rx-magic-trigger]') || document.getElementById('checkout') || document.querySelector('button[name="checkout"]:not([disabled])');
      if (!trigger || trigger.disabled) {
        cartNotice(text('rx_notice_checkout_unavailable', 'Your frame and matching lens are in your cart, but the secure checkout button is unavailable. Continue from the cart.'), true);
        return false;
      }
      var detail = { cart: cart, prescriptionGroupId: groupId, source: 'prescription-buy-now' };
      document.dispatchEvent(new CustomEvent('jodykoes:checkout:started', { detail: detail }));
      document.dispatchEvent(new CustomEvent('cart:checkout:started', { detail: detail }));
      window.dispatchEvent(new CustomEvent('cart:checkout:started', { detail: detail }));
      trigger.click();
      return true;
    });
  }
  function missingCartItems(cart, expected) {
    return expected.filter(function (wanted) {
      return !cart.items.some(function (line) {
        return cartLineMatchesExpected(line, wanted) && Number(line.quantity) >= Number(wanted.quantity || 1);
      });
    });
  }
  function delay(milliseconds) {
    return new Promise(function (resolve) { window.setTimeout(resolve, milliseconds); });
  }
  function confirmCartItems(expected, attempt) {
    return fetchFreshCart().then(function (cart) {
      if (cartContainsExpected(cart, expected)) return cart;
      if (attempt < 5) return delay([150, 300, 600, 1000, 1500][attempt]).then(function () { return confirmCartItems(expected, attempt + 1); });
      return cart;
    });
  }
  function removePrescriptionGroup(groupId) {
    return fetchFreshCart().then(function (cart) {
      return cart.items.filter(function (line) {
        return itemGroup(line) === groupId;
      }).reduce(function (chain, line) {
        return chain.then(function () {
          if (!window.JodyKoesTheme || typeof window.JodyKoesTheme.changeCartLine !== 'function') throw new Error(text('rx_cart_recovery_unavailable', 'Cart recovery is unavailable.'));
          return window.JodyKoesTheme.changeCartLine(line.key, 0);
        });
      }, Promise.resolve());
    }).then(fetchFreshCart).then(function (cart) {
      if (cart.items.some(function (line) { return itemGroup(line) === groupId; })) {
        throw new Error(text('rx_recovery_pair_failure', 'Shopify still shows an unmatched prescription item.'));
      }
      return cart;
    });
  }
  function normalizePrescriptionPair(cart, groupId) {
    if (!groupId) return Promise.resolve(cart);
    return cart.items.filter(function (line) {
      return itemGroup(line) === groupId && Number(line.quantity) > 1;
    }).reduce(function (chain, line) {
      return chain.then(function () {
        return window.JodyKoesTheme.changeCartLine(line.key, 1);
      });
    }, Promise.resolve()).then(fetchFreshCart);
  }
  function addItems(items, message, groupId, checkoutOnly) {
    var originalNextText = next.textContent;
    next.disabled = true;
    next.setAttribute('aria-busy', 'true');
    next.textContent = checkoutOnly ? text('rx_button_preparing_checkout', 'Preparing checkout…') : text('rx_button_adding', 'Adding to cart…');
    if (buyNowButton) { buyNowButton.disabled = true; buyNowButton.setAttribute('aria-busy', 'true'); buyNowButton.textContent = text('rx_button_buy_now_preparing', 'Preparing…'); }
    frameOnly.disabled = true;

    function addAndConfirm() {
      var emptyCartCheck = checkoutOnly ? fetchFreshCart().then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || cart.items.length || Number(cart.item_count)) {
          var occupied = new Error(text('rx_error_cart_not_empty', 'Buy now checks out only this frame and its selected lens. Your cart already has items, so nothing was changed. Use Add to cart to keep those items, or empty the cart and try again.'));
          occupied.checkoutOnly = true;
          throw occupied;
        }
        return waitForMagicCheckout(0);
      }).then(function (ready) {
        if (ready) return;
        var unavailable = new Error(text('rx_error_magic_not_ready', 'Razorpay Magic Checkout is not ready on this page. Nothing was added; please try again or use Add to cart.'));
        unavailable.checkoutOnly = true;
        throw unavailable;
      }) : Promise.resolve();
      return emptyCartCheck.then(function () { return postCartItems(items); }).then(function () {
        return confirmCartItems(items, 0).then(function (cart) {
          var missing = missingCartItems(cart, items);
          if (!missing.length) return normalizePrescriptionPair(cart, groupId);
          return postCartItems(missing).then(function () {
            return confirmCartItems(items, 0).then(function (retriedCart) {
              if (missingCartItems(retriedCart, items).length) throw new Error(text('rx_cart_pair_not_confirmed', 'Shopify did not confirm both the frame and its selected lens.'));
              return normalizePrescriptionPair(retriedCart, groupId);
            });
          });
        });
      }).then(function (cart) {
        if (checkoutOnly && !cartIsOnlyPrescriptionPair(cart, groupId)) {
          var changed = new Error(text('rx_error_cart_pair_changed', 'Your cart changed while the prescription pair was being prepared. The pair was removed and your other cart items were kept. Please try Buy now again.'));
          changed.checkoutOnly = true;
          throw changed;
        }
        return cart;
      });
    }

    var operation = window.JodyKoesTheme && typeof window.JodyKoesTheme.enqueueCartOperation === 'function'
      ? window.JodyKoesTheme.enqueueCartOperation(addAndConfirm)
      : addAndConfirm();
    operation.then(function (cart) {
      if (checkoutOnly) {
        notifyCart(cart, text('rx_notice_checkout_ready', 'Your prescription frame and matching lens are ready for secure checkout.'));
        close();
        return triggerMagicCheckout(cart, groupId);
      }
      notifyCart(cart, message);
      close();
    }).catch(function (problem) {
      var recovery = groupId ? removePrescriptionGroup(groupId) : Promise.resolve();
      return recovery.then(function () {
        var message = problem.checkoutOnly ? problem.message : (groupId ? text('rx_error_pair_cleanup', 'Shopify could not confirm the full frame-and-lens pair, so the incomplete pair was removed. Please try again.') : problem.message);
        showError(message);
        if (window.JodyKoesTheme && typeof window.JodyKoesTheme.showCartNotice === 'function') window.JodyKoesTheme.showCartNotice(message, true);
      }).catch(function () {
        var message = text('rx_error_cleanup_failed', 'The cart could not confirm both items, and automatic cleanup did not finish. Open your cart and check before placing the order.');
        showError(message);
        if (window.JodyKoesTheme && typeof window.JodyKoesTheme.showCartNotice === 'function') window.JodyKoesTheme.showCartNotice(message, true);
      });
    }).finally(function () {
      next.disabled = false;
      next.removeAttribute('aria-busy');
      next.textContent = originalNextText;
      if (buyNowButton) { buyNowButton.disabled = false; buyNowButton.removeAttribute('aria-busy'); buyNowButton.textContent = text('rx_button_buy_now', 'Buy now'); }
      frameOnly.disabled = false;
    });
  }
  function addPrescriptionOrder(checkoutOnly) {
    var groupId = 'JK-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    var properties = commonProperties(groupId);
    var frameProperties = Object.assign({ 'Purchase Type': 'Prescription Frame' }, properties);
    var lensProperties = {
      'Purchase Type': 'Prescription Lens', '_JK Prescription Group ID': groupId,
      'Product Category': properties['Product Category'], 'Prescription Type': state.type,
      'Submission Method': state.method, 'Prescription Status': properties['Prescription Status'],
      'Associated Frame': state.frameName
    };
    addItems([
      { id: state.frameId, quantity: 1, properties: frameProperties },
      { id: state.lens.variant, quantity: 1, properties: lensProperties }
    ], text('rx_recovery_success', 'Your frame and matching lens are confirmed in your cart.'), groupId, Boolean(checkoutOnly));
  }
  function addFrameOnly() {
    addItems([{
      id: state.frameId, quantity: 1,
      properties: {
        'Purchase Type': 'Frame Only', 'Product Category': state.category === 'optical' ? 'Optical Glasses' : 'Sunglasses',
        'Prescription Type': 'Not Applicable', 'Submission Method': 'Not Applicable', 'Prescription Status': 'Not Required'
      }
    }], text('rx_frame_only_success', 'Your frame has been added to your cart.'));
  }
  function submitNativeUpload(checkoutOnly, cartWasChecked) {
    var problem = !state.uploadFile || !fileInput.files || !fileInput.files.length ? text('rx_error_file_missing', 'Choose a prescription file before continuing.') :
      (!isAcceptedFile(state.uploadFile) ? acceptedFileText() :
        (!uploadConsent.checked ? text('rx_error_file_consent', 'Confirm the file access notice or choose Email later or WhatsApp us later.') : ''));
    if (problem) { showError(problem); return; }
    var form = state.form;
    var variantControl = form && form.querySelector('[data-product-variant-select]');
    var selectedOption = variantControl && variantControl.tagName === 'SELECT' ? variantControl.options[variantControl.selectedIndex] : variantControl;
    var frameVariant = Number(variantControl && variantControl.value);
    if (!form || !frameVariant || (selectedOption && selectedOption.dataset.available === 'false')) {
      showError(text('rx_error_frame_unavailable', 'Choose an available frame option before uploading.'));
      return;
    }
    if (checkoutOnly && !cartWasChecked) {
      if (buyNowButton) { buyNowButton.disabled = true; buyNowButton.setAttribute('aria-busy', 'true'); buyNowButton.textContent = text('rx_button_checking_cart', 'Checking cart…'); }
      return fetchFreshCart().then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || cart.items.length || Number(cart.item_count)) {
          throw new Error(text('rx_error_cart_not_empty', 'Buy now checks out only this frame and its selected lens. Your cart already has items, so nothing was changed. Use Add to cart to keep those items, or empty the cart and try again.'));
        }
        return waitForMagicCheckout(0);
      }).then(function (ready) {
        if (!ready) throw new Error(text('rx_error_magic_upload_not_ready', 'Razorpay Magic Checkout is not ready on this page. Nothing was uploaded; please try again or use Add to cart.'));
        submitNativeUpload(true, true);
      }).catch(function (problem) {
        showError(problem.message || text('rx_error_upload_cart_check', 'Your cart could not be checked. Nothing was changed; please try again.'));
        if (buyNowButton) { buyNowButton.disabled = false; buyNowButton.removeAttribute('aria-busy'); buyNowButton.textContent = text('rx_button_buy_now', 'Buy now'); }
      });
    }
    state.frameId = frameVariant;
    state.framePrice = Number(selectedOption && selectedOption.dataset.price) || state.framePrice;
    var groupId = 'JK-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    var values = {
      groupId: groupId,
      privacyConsent: 'Yes',
      category: state.category === 'optical' ? 'Optical Glasses' : 'Sunglasses',
      type: state.type,
      lensName: state.lens.name,
      lensVariant: String(state.lens.variant)
    };
    Object.keys(values).forEach(function (key) {
      var field = modal.querySelector('[data-jk-rx-upload-property="' + key + '"]');
      if (field) field.value = values[key];
    });
    uploadPropertyFields.forEach(function (field) { field.disabled = false; });
    fileInput.disabled = false;
    uploadConsent.disabled = false;
    var returnTo = form.querySelector('[data-jk-rx-return-to]');
    if (returnTo) returnTo.value = route('cart') + '?jk_rx_upload=' + encodeURIComponent(groupId) + (checkoutOnly ? '&jk_rx_buy_now=1' : '');
    var quantity = form.querySelector('[name="quantity"]');
    if (quantity) quantity.value = '1';

    var pending = {
      groupId: groupId,
      frameVariant: frameVariant,
      frameName: state.frameName,
      category: values.category,
      type: state.type,
      lensVariant: state.lens.variant,
      lensName: state.lens.name,
      fileName: state.uploadFile.name,
      buyNow: Boolean(checkoutOnly),
      attemptedAt: Date.now()
    };
    try { window.sessionStorage.setItem('jkRxUploadPending', JSON.stringify(pending)); }
    catch (_) {
      uploadPropertyFields.forEach(function (field) { field.disabled = true; });
      fileInput.disabled = true;
      uploadConsent.disabled = true;
      showError(text('rx_upload_session_failed', 'This browser cannot save the brief cart recovery details needed to pair your frame and lens. Enable session storage or choose Email later or WhatsApp us later.'));
      return;
    }

    next.disabled = true;
    next.setAttribute('aria-busy', 'true');
    next.textContent = text('rx_button_uploading', 'Uploading…');
    if (checkoutOnly && buyNowButton) { buyNowButton.disabled = true; buyNowButton.setAttribute('aria-busy', 'true'); buyNowButton.textContent = text('rx_button_uploading', 'Uploading…'); }
    try {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    } catch (_) {
      try { window.sessionStorage.removeItem('jkRxUploadPending'); } catch (__) {}
      uploadPropertyFields.forEach(function (field) { field.disabled = true; });
      fileInput.disabled = true;
      uploadConsent.disabled = true;
      next.disabled = false;
      next.removeAttribute('aria-busy');
      if (buyNowButton) { buyNowButton.disabled = false; buyNowButton.removeAttribute('aria-busy'); buyNowButton.textContent = text('rx_button_buy_now', 'Buy now'); }
      showError(text('rx_upload_start_failed', 'Shopify could not start the upload. Please try again or choose Email later or WhatsApp us later.'));
    }
  }

  if (fileInput) {
    fileInput.addEventListener('change', function () {
      var file = fileInput.files && fileInput.files[0];
      if (!file) return;
      if (!isAcceptedFile(file)) {
        fileInput.value = '';
        state.uploadFile = null;
        fileName.textContent = text('rx_file_empty', 'No file selected');
        removeFile.hidden = true;
        showError(acceptedFileText());
        return;
      }
      state.uploadFile = file;
      fileName.textContent = file.name;
      removeFile.hidden = false;
      showError('');
    });
  }
  if (removeFile) removeFile.addEventListener('click', function () {
    if (fileInput) fileInput.value = '';
    if (state) state.uploadFile = null;
    fileName.textContent = text('rx_file_empty', 'No file selected');
    removeFile.hidden = true;
    showError('');
  });

  modal.addEventListener('click', function (event) {
    var target = event.target.closest('[data-type]');
    if (target) {
      state.type = target.dataset.type;
      if (state.type === 'Frame Only') { state.method = 'Not Applicable'; addFrameOnly(); return; }
      state.step = 'method'; render(); return;
    }
    target = event.target.closest('[data-method]');
    if (target) {
      state.method = target.dataset.method;
      state.step = state.method === 'Manually' ? 'prescription' : (state.method === 'Upload Prescription' ? 'upload' : 'lens');
      render(); return;
    }
    target = event.target.closest('[data-lens]');
    if (target) {
      var index = Number(target.dataset.lens);
      var product = catalog[state.category][state.type][index];
      var variant = product && product.variants.find(function (item) { return item.available; });
      if (!variant || !product.available) { showError(text('rx_lens_sold_out', 'Sold out')); return; }
      if (priceCache[variant.id] == null) { showError(text('rx_error_price_wait', 'Wait until the current lens price is verified.')); loadPrices(catalog[state.category][state.type]); return; }
      state.lens = { name: lensLabel(product, variant), category: state.category, type: state.type, productIndex: index,
        productId: product.productId, variant: variant.id, price: priceCache[variant.id], image: variant.image || product.image };
      render(); return;
    }
    if (event.target.matches('[data-dual]')) { state.pdMode = event.target.checked ? 'dual' : 'single'; render(); return; }
    var field = event.target.closest('[data-field]');
    if (field) {
      var key = field.dataset.field;
      if (/^(odsph|odcyl|odaxis|odadd|ossph|oscyl|osaxis|osadd)$/.test(key)) {
        state.eye[key.slice(0, 2)][key.slice(2)] = field.value;
        if (key.endsWith('cyl') && field.value === '0.00') state.eye[key.slice(0, 2)].axis = '';
      } else state[key] = field.value;
    }
  });
  modal.addEventListener('change', function (event) {
    var field = event.target.closest('[data-field]');
    if (field) {
      var key = field.dataset.field;
      if (/^(odsph|odcyl|odaxis|odadd|ossph|oscyl|osaxis|osadd)$/.test(key)) {
        state.eye[key.slice(0, 2)][key.slice(2)] = field.value;
        if (key.endsWith('cyl') && field.value === '0.00') { state.eye[key.slice(0, 2)].axis = ''; render(); }
      } else state[key] = field.value;
    }
    if (event.target.matches('[data-dual]')) { state.pdMode = event.target.checked ? 'dual' : 'single'; render(); }
    var variantSelect = event.target.closest('[data-lens-variant]');
    if (variantSelect) {
      var productIndex = Number(variantSelect.dataset.lensVariant);
      var product = catalog[state.category][state.type][productIndex];
      var variant = selectedVariant(product, variantSelect.value);
      if (!variant || !variant.available) { showError(text('rx_lens_sold_out', 'Sold out')); return; }
      if (priceCache[variant.id] == null) { showError(text('rx_error_price_wait', 'Wait until the current lens price is verified.')); loadPrices(catalog[state.category][state.type]); return; }
      state.lens = { name: lensLabel(product, variant), category: state.category, type: state.type, productIndex: productIndex,
        productId: product.productId, variant: variant.id, price: priceCache[variant.id], image: variant.image || product.image };
      render();
    }
  });
    modal.querySelectorAll('[data-jk-rx-close]').forEach(function (button) { button.addEventListener('click', close); });
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-jk-prescription-open]');
    if (button) { event.preventDefault(); open(button); }
  });
  back.addEventListener('click', function () {
    state.step = ({ method: 'type', prescription: 'method', upload: 'method', lens: state.method === 'Manually' ? 'prescription' : (state.method === 'Upload Prescription' ? 'upload' : 'method'), review: 'lens' })[state.step] || 'type';
    render();
  });
  next.addEventListener('click', function () {
    var problem = validate();
    if (problem) { showError(problem); return; }
    if (state.step === 'method') state.step = state.method === 'Manually' ? 'prescription' : (state.method === 'Upload Prescription' ? 'upload' : 'lens');
    else if (state.step === 'upload') state.step = 'lens';
    else if (state.step === 'prescription') state.step = 'lens';
    else if (state.step === 'lens') state.step = 'review';
    else if (state.step === 'review') { if (state.method === 'Upload Prescription') submitNativeUpload(); else addPrescriptionOrder(); return; }
    render();
  });
  if (buyNowButton) buyNowButton.addEventListener('click', function () {
    if (!state || state.step !== 'review') return;
    var problem = validate();
    if (problem) { showError(problem); return; }
    if (state.method === 'Upload Prescription') submitNativeUpload(true, false);
    else addPrescriptionOrder(true);
  });
  document.addEventListener('keydown', function (event) {
    if (modal.hidden) return;
    if (event.key === 'Escape') { close(); return; }
    if (event.key !== 'Tab') return;
    var focusable = Array.from(modal.querySelectorAll('button:not([disabled]):not([hidden]), select:not([disabled]), input:not([disabled]), a[href]'))
      .filter(function (element) { return element.offsetParent !== null; });
    if (!focusable.length) return;
    var first = focusable[0]; var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
})();
